import { gsap } from "gsap";

export default function initMobileNav() {
  const mobileNavOpen = document.getElementById("mobile_nav_open");
  const mobileNavClose = document.getElementById("mobile_nav_close");
  const headerMenu = document.getElementById("header_menu");
  const secondaryDropdown = document.querySelector(".secondary_dropdown");
  const mobileBreakpoint = 880;

  if (!mobileNavOpen || !mobileNavClose || !headerMenu) return;

  // Initialize GSAP timelines
  const openTimeline = gsap.timeline({ paused: true });
  const closeTimeline = gsap.timeline({ paused: true });

  // Function to disable scrolling
  const disableScroll = () => {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${window.scrollY}px`;
    document.body.dataset.scrollPosition = window.scrollY;
  };

  // Function to enable scrolling
  const enableScroll = () => {
    const scrollY = document.body.dataset.scrollPosition;
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0"));
  };

  // Setup open animation
  openTimeline
    .set(headerMenu, { display: "flex", opacity: 0 })
    .to(headerMenu, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
    })
    .from(
      headerMenu.querySelectorAll("li"),
      {
        y: -20,
        opacity: 0,
        stagger: 0.05,
        duration: 0.4,
        ease: "back.out(1.7)",
      },
      "-=0.1"
    );

  // Setup close animation
  closeTimeline
    .to(headerMenu, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
    })
    .set(headerMenu, { display: "none" });

  mobileNavOpen.addEventListener("click", () => {
    document.body.classList.add("nav-open");
    headerMenu.classList.add("is-active");

    // Disable scrolling
    disableScroll();

    // Play open animation
    closeTimeline.pause(0);
    openTimeline.restart();
  });

  mobileNavClose.addEventListener("click", () => {
    // Play close animation, then remove classes when complete
    openTimeline.pause();
    closeTimeline.restart().eventCallback("onComplete", () => {
      headerMenu.classList.remove("is-active");
      document.body.classList.remove("nav-open");

      // Enable scrolling
      enableScroll();
    });
  });

  // Close menu when clicking outside
  document.addEventListener("click", (e) => {
    if (
      headerMenu.classList.contains("is-active") &&
      !headerMenu.contains(e.target) &&
      !mobileNavOpen.contains(e.target) &&
      !mobileNavClose.contains(e.target)
    ) {
      // Play close animation, then remove classes when complete
      openTimeline.pause();
      closeTimeline.restart().eventCallback("onComplete", () => {
        headerMenu.classList.remove("is-active");
        document.body.classList.remove("nav-open");

        // Enable scrolling
        enableScroll();
      });
    }
  });

  // Handle Applications dropdown menu
  if (secondaryDropdown) {
    const dropdownTrigger = secondaryDropdown.querySelector("div");
    const dropdownList = secondaryDropdown.querySelector("ul");
    const dropdownIcon = dropdownTrigger.querySelector(".icon svg");

    // Simple function to open dropdown
    function openDropdown() {
      secondaryDropdown.classList.add("active");
      gsap.to(dropdownIcon, { rotation: 180, duration: 0.3 });
      gsap.to(dropdownList, {
        display: "block",
        opacity: 1,
        height: "auto",
        duration: 0.3,
        ease: "power2.out",
      });
    }

    // Simple function to close dropdown
    function closeDropdown() {
      gsap.to(dropdownIcon, { rotation: 0, duration: 0.3 });
      gsap.to(dropdownList, {
        opacity: 0,
        height: 0,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => {
          gsap.set(dropdownList, { display: "none" });
          secondaryDropdown.classList.remove("active");
        },
      });
    }

    // Initial state
    gsap.set(dropdownList, {
      display: "none",
      opacity: 0,
      height: 0,
    });

    // Mobile: Click behavior
    dropdownTrigger.addEventListener("click", (e) => {
      if (window.innerWidth < mobileBreakpoint) {
        e.preventDefault();
        e.stopPropagation();

        if (secondaryDropdown.classList.contains("active")) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }
    });

    // Desktop: Hover behavior
    if (window.innerWidth >= mobileBreakpoint) {
      secondaryDropdown.addEventListener("mouseenter", () => {
        openDropdown();
      });

      secondaryDropdown.addEventListener("mouseleave", () => {
        closeDropdown();
      });
    }

    // Handle window resize
    window.addEventListener("resize", () => {
      // Close dropdown when resizing
      closeDropdown();

      // Re-attach hover events if desktop
      if (window.innerWidth >= mobileBreakpoint) {
        secondaryDropdown.addEventListener("mouseenter", openDropdown);
        secondaryDropdown.addEventListener("mouseleave", closeDropdown);
      } else {
        secondaryDropdown.removeEventListener("mouseenter", openDropdown);
        secondaryDropdown.removeEventListener("mouseleave", closeDropdown);
      }
    });
  }
}
